<template>
   <div class="about-second-section" v-if="about != null">
        <div class="container">
            <div class="column-container">
                <div class="col-left">
                    <div class="section-title-page">
                        <h4>{{about.about_second_section}}</h4>
                        <h2>{{about.about_second_title}}</h2>
                        <div class="desc" v-html="about.about_second_desc"></div>
                    </div>
                    <div class="number-of-section">
                        <span>01</span>
                    </div>
                    <div class="about-second-map-mobile">
                        <img :src="about.about_second_map" alt="" id="about-location-map-mobile">
                    </div>
                    <div class="logo-monaco">
                        <img :src="setup.logo_dark" alt="">
                    </div>
                    <div class="map-list">
                        <ul>
                            <li v-for="(item, index) in about.about_second_pins.slice(0,6)" :data-count="index + 1">{{item.desc}}</li>
                        </ul>
                        <ul>
                            <li v-for="(item, index) in about.about_second_pins.slice(6)" :data-count="index + 7">{{item.desc}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-right">
                    <div class="location-map">
                        <img :src="about.about_second_map" alt="">
                    </div>
                </div>
            </div>
            
        </div>
       
   </div>
</template>

<script>
    export default {
        name: 'about-elem-second',
        components: {
        },
        data () {
            return {
                mapResize: false,
            }
        },
        methods: { 
            mapResizeInit() {
                this.mapResize = true;
                document.getElementById('header').classList.add('slicky', 'notvisible');
                // document.getElementById('header').classList.add('notvisible');
                // document.getElementById('secret-btns').classList.add('disabled');
                document.body.classList.add('overlay-open');
            },
            closeMap() {
                this.mapResize = false;
                document.getElementById('header').classList.remove('slicky', 'notvisible');
                // document.getElementById('header').classList.remove('notvisible');
                // document.getElementById('secret-btns').classList.remove('disabled');
                document.body.classList.remove('overlay-open');
            },
            initPinchZoomer() {
                var _self = this;
                var image = new Image();
                image.onload = function () {
                    // console.log('work');
                    if ($(window).width() < 740) {
                        $("#about-location-map-mobile").pinchzoomer({
                            initZoom: 1,
                            minZoom: 1,
                        });
                    }
                }
                image.src = this.about.about_second_map;
            }
        },
        computed: {
            about() {
                return this.$store.state.about
            },
            setup() {
                return this.$store.state.pageSetup
            },
        },
        created () {
        },
        mounted () {
            this.initPinchZoomer();
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-second.scss';
    // @import '@/styles/components/about/about-respond/about-elem-second-respond.scss';
</style>